import {InitBurger} from './components/burger_menu.js'

$(document).ready(function (){
    console.log("ready")
    InitBurger()
})

